<template>
  <validation-observer v-if="status === CARD_CREATE_STATUS.create" v-slot="{handleSubmit}" ref="cardFormObs">
    <form @submit.prevent="handleSubmit(addCard)">
      <div class="title  py-4">
        <h5>Добавить карту</h5>
      </div>
      <v-row no-gutters class="mx-n2">
        <v-col cols="12">
          <custom-input-text
              pattern="####-####-####-####"
              label="Номер карты"
              name="Номер карты"
              rules="required|card_number"
              vid="card_number"
              v-model="newCardForm.number"
              placeholder="8888-8888-8888-8888"
          ></custom-input-text>
        </v-col>
        <v-col cols="12">
          <custom-input-text
              label="Срок действия"
              rules="required"
              name="Срок действия"
              vid="expiry_date"
              v-model="newCardForm.expiry_date"
              pattern="##/##"
              placeholder="00/00"
          ></custom-input-text>
        </v-col>
        <v-col cols="12" class="text-right">
          <v-btn color="primary" width="100%" type="submit" :loading="loading">Добавить
          </v-btn>
        </v-col>
      </v-row>
    </form>
  </validation-observer>
  <validation-observer v-slot="{handleSubmit}" v-else tag="div" ref="confirmFormObs">
    <div class="title pb-2 pt-4">
      <h5>Подтверждение</h5>
    </div>
    <p class="mb-1">Смс код отправлен на телефон номер</p>
    <form @submit.prevent="handleSubmit(confirmHandler)">
      <custom-input-text
          pattern="######"
          placeholder="666666"
          rules="required"
          vid="confirm"
          name="Код"
          label="Код"
          v-model="code"
      ></custom-input-text>
      <v-sheet color="primary" dark class="pa-2 px-4 mb-3 rounded" v-if="timeout >0">
        Вы можете снова отправить через 00:{{timeout.length === 1 ? `0${timeout}` : timeout}}
      </v-sheet>
      <v-btn @click="addCard" v-else color="primary" width="100%" class="mb-2">Отправить еще</v-btn>
      <div class="text-center">
        <v-btn color="primary" width="100%" :loading="loading" type="submit">Подтверждать</v-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
import addCardMixin from "@/components/card/addCardMixin";
import {messages} from "@/utils/constants";

export default {
  name: 'OtherCardForm',
  data() {
    return {
      newCardForm: {
        number: null,
        expiry_date: null
      },
    }
  },
  mixins: [addCardMixin],
  methods: {
    async addCard() {
      if (this.mko_id) {
        try {
          this.loading = true
          const formData = {
            ...this.newCardForm,
            mko_id: this.mko_id,
          }
          if(this.user_id) formData.user_id = this.user_id
          const {data: {data}} = await this.$http.post('admin/users/add-card', formData)
          if(data.user_id) this.temp_user_id = data.user_id
          this.transaction_id = data.transaction_id
          this.card_id = data.card_id
          this.status = this.CARD_CREATE_STATUS.confirm
          this.loading = false
          this.setTime()
        } catch (e) {
          this.loading = false
          this.$setResponseError({error: e})
          this.$setFormError({error: e, obs: this.$refs['cardFormObs']})
        }
      } else {
        this.$setErrors({text: messages.selectMkoBeforeCreateCard})
      }
    },
    async confirmHandler() {
      this.loading = true
      try {
        const formData = {
          ...this.newCardForm,
          mko_id: this.mko_id,
          code: this.code,
          transaction_id: this.transaction_id
        }
        if(this.user_id) {
          formData.user_id = this.user_id
        }
        const {data: {data}} = await this.$http.post('admin/users/confirm-card', formData)
        this.loading = false;
        this.$emit('save', {
          card_id: data.id,
          pan: data.pan,
          phone: data.phone
        })
        this.$setSuccess({text: messages.onAddedCard})
        this.$emit('done')
        this.clearCardForm()
      } catch (e) {
        this.loading = false
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs['confirmFormObs']})
      }

    },
    clearCardForm() {
      this.newCardForm = {
        number: null,
        phone: null,
        mko_id: this.mko_id,
        expiry_date: null
      }
      this.clear()

    },
  }

}
</script>